import * as React from 'react';
import classnames from 'classnames';

import './styles.scss';
import { format } from 'date-fns';

const SlideDown = require('react-slidedown').SlideDown;

export interface EventProps {
    id: number;
    name: string;
    website: string;
    start_date: string;
    end_date: string;
    start_time: string;
    end_time: string;
}

export interface Props {
    events: EventProps[];
    isShown: boolean;
}

export interface State {
    isShown: boolean;
}

export default class UpcomingEvents extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isShown: props.isShown,
        };

        this.handleToggleClick = this.handleToggleClick.bind(this);
    }

    public render() {
        return (
            <div className='VenuePage--detail VenuePage--detail__expandable'>
                <div className='VenuePage--detail-headline-container' onClick={this.handleToggleClick}>
                    <h3 className='VenuePage--detail-headline VenuePage--detail-headline__expandable'>
                        Upcoming events
                        <i
                            className={classnames('icon-hb-nx-arrow-down-16', { 'icon-hb-nx-arrow-down-16__flipped': this.state.isShown })}
                        />
                    </h3>
                </div>

                <div className='VenuePage--additional-detail-container'>
                    <SlideDown className={'VenuePage--row'}>
                        {this.state.isShown && <div className='Events'>{this.props.events.map(this.renderEvent)}</div>}
                    </SlideDown>
                </div>
            </div>
        );
    }

    private handleToggleClick(e: React.SyntheticEvent<HTMLElement>) {
        this.setState({ isShown: !this.state.isShown });
    }

    private renderEvent(event_data: EventProps, idx: number) {
        let start_date = format(new Date(event_data.start_date), 'MMM d, Y');
        let end_date = format(new Date(event_data.end_date), 'MMM d, Y');
        let date_string = start_date;
        if (start_date != end_date) {
            date_string += ' - ' + end_date;
        }

        let hasTime = false;
        let time_string = '';
        if (!!event_data.start_time && !!event_data.end_time) {
            let start_time = format(new Date(event_data.start_date + ' ' + event_data.start_time), 'h:mma');
            let end_time = format(new Date(event_data.end_date + ' ' + event_data.end_time), 'h:mma');
            time_string = start_time + ' - ' + end_time;
            hasTime = true;
        }

        return (
            <div className='Events--event-row' key={idx}>
                <div className='Events--row-icon'>
                    <i className='icon-hb-nx-calendar-star' />
                </div>
                <div className='Events--row-data'>
                    <div className='Events--row-name'>{event_data.name}</div>
                    <div className='Events--row-time'>
                        {date_string}
                        {hasTime && <span>{` ${time_string}`}</span>}
                    </div>
                    <div className='Events--row-website'>
                        <a href={event_data.website} target='_blank'>
                            {event_data.website}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}
